import React, { useState, useContext, useMemo,useEffect } from "react";
import constants from "../../constants";
import { adminEmailBody } from "../../util";
import AlertContext from "../../context/AlertContext";
import Button from "../Button";
// import UploadSvg from "../../Svg/UploadIconsvg";
import PlusIconSvg from "../../Svg/PlusIconSvg";
// import OnBoardCompanies from "../OnBoardCompanies";
import UserDetails from "../Admin/Batch/Users/UserDetails";
import OnBoardUniversity from "../OnBoardUniversity";
// import OnboardAccount from "../OnboardAccount";
import OnboardAccountModal from "../OnboardAccountModal";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";
const SuperAdminControls = () => {

  const Alert = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const [showForm, setShowForm] = useState(false);
  const [userInput, setUserInput] = useState({});
  const [addUser, setAddUser] = useState(false);

  // 👇 Drawer state
  // const [openUniversityDrawer, setOpenUniversityDrawer] = useState(false);
  const [openUniversityModal, setOpenUniversityModal] = useState(false);

  // --------------------------------------------------
  // Open OnBoardUniversity Drawer
  // --------------------------------------------------
  const handleUploadUniversity = () => {
  setOpenUniversityModal(true);
};

  // const handleUploadFbfile = () => {
  //   Alert.setShowNotify({
  //     show: true,
  //     size: "md",
  //     showClose: true,
  //     hideButton: true,
  //     title: "Add University",
  //     msg: <OnBoardCompanies />,
  //   });
  // };

  const onAddAdmin = (event) => {
    event.preventDefault();
    setShowForm(true);
    setUserInput({
      emailBody: adminEmailBody,
      role: constants.Roles.admin,
    });
  };

  return (
    <>
      
      {/* -------- Add University Button -------- */}
      <Button
        size="sm"
        disable={false}
        onClick={handleUploadUniversity}
        icon={{
          type: "leading",
          icon: <PlusIconSvg stroke="#ffffff" type={4} />,
        }}
        hierarchy={{
          type: "primary",
          buttonText: "Add Account",
        }}
      />

      {/* -------- Upload University File Button -------- */}
      {/* <Button
        size="sm"
        disable={false}
        onClick={handleUploadFbfile}
        icon={{
          type: "leading",
          icon: <UploadSvg stroke="#344054" />,
        }}
        hierarchy={{
          type: "secondaryGrey",
          buttonText: "Add Univesity",
        }}
      /> */}

      {/* -------- Add Admin Button -------- */}
      {/* <Button
        size="sm"
        disable={false}
        onClick={onAddAdmin}
        icon={{
          type: "leading",
          icon: <PlusIconSvg stroke="#344054" type={4} />,
        }}
        hierarchy={{
          type: "secondaryGrey",
          buttonText: "Admin",
        }}
      /> */}

      {/* -------- OnBoardUniversity Drawer -------- */}
      <OnboardAccountModal
        isOpen={openUniversityModal}
        onClose={() => setOpenUniversityModal(false)}
      />

      {/* -------- Admin Form Popup -------- */}
      {showForm && (
        <UserDetails
          showUserFormPopup={showForm}
          newUserInput={userInput}
          setNewUserInput={setUserInput}
          setShowUserFormPopup={setShowForm}
          addUser={addUser}
          setAddUser={setAddUser}
        />
      )}
    </>
  );
};

export default SuperAdminControls;
